import React from "react";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import {withStyles} from "@material-ui/core/styles";
import {getTranslation} from "../../helpers/get-translation";

const styles = theme => ({
	root:{
	},
	mailButton: {
		backgroundColor: "#db4437",
		color: "#fff",
		"&:hover": {
			backgroundColor: "#ad362c"
		}
	},
});

function EmailButton(props) {
	const { classes, onClick } = props;

	return (
		<div className={classes.root}>
			<Button
				className={classes.mailButton}
				variant="contained"
				onClick={() => onClick()}
			>
				<div>
					<img src='static/images/login-screen/mail.svg'/>
					<span>{getTranslation("login_email")}</span>
				</div>
			</Button>
		</div>
	)
}

EmailButton.propTypes = {
	classes: PropTypes.shape({
		root: PropTypes.string.isRequired,
	}).isRequired,

	onClick: PropTypes.func.isRequired
};

export default withStyles(styles)(EmailButton);